<app-header></app-header>
<app-cart></app-cart>
<app-contact></app-contact>
<app-footer></app-footer>

